export default "__VITE_PUBLIC_ASSET__7d2b4ad0__"